<template>
  <div id="signature-pad">
    <vueSignature ref="signature" class="form-control" :sigOption="option" :w="'440px'"
                  :h="'320px'"></vueSignature>
    <br/>
    <div class="btn-group btn-group-sm" role="group" aria-label="...">
      <button class="btn btn-info btn-sm" @click="clear">Limpiar</button>
      <button class="btn btn-primary btn-sm" @click="save">Usar</button>
    </div>
  </div>
</template>

<script>
import vueSignature from 'vue-signature';

export default {
  name: 'SignaturePad',
  components: {
    vueSignature
  },
  data() {
    return {
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'transparent'
      },
      disabled: false,
    };
  },
  methods: {
    save() {
      const png = this.$refs.signature.save();
      this.$emit('input', { png });
    },
    clear() {
      this.$refs.signature.clear();
    }
  }

};
</script>
